import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import { AccountsDropdownIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import createAbsolutePath from "createAbsolutePath";
import { ActiveProfileQuery } from "operations";

const SwitchToAccountDropdownContainer = styled.div`
  display: flex;
`;

export const basePath = "/users/logIntoAccount";

const SwitchToAccountDropdown = ({
  otherAccounts,
}: Pick<ActiveProfileQuery, "otherAccounts">) => {
  if (!otherAccounts?.length) {
    return null;
  }

  return (
    <SwitchToAccountDropdownContainer>
      <NavbarDropdown
        rightPosition
        trigger={
          <Trigger
            label={messages.switchTo}
            id={AccountsDropdownIds.AccountsOptionSwitchTo}
          />
        }
      >
        <DropdownMenuGroup>
          {otherAccounts.map(({ name, id }) => {
            return (
              <DropdownMenuTextLink
                to={createAbsolutePath(`${basePath}/${id}`)}
                message={name}
                testId="switch-to-option"
              />
            );
          })}
        </DropdownMenuGroup>
      </NavbarDropdown>
    </SwitchToAccountDropdownContainer>
  );
};

export default SwitchToAccountDropdown;
